import LegalLayout from "./LegalLayout";

export default function AvisoLegal() {
  return (
    <LegalLayout title="Aviso Legal">
      <p>En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico (LSSICE), se informa a los usuarios de los siguientes datos del titular de este sitio web:</p>

      <h2>1. Titular del sitio web</h2>
      <ul>
        <li><strong>Titular:</strong> Ainhoa Pilar Quinga Parrales (Dentainhoa)</li>
        <li><strong>Actividad:</strong> Servicios de higiene dental a domicilio</li>
        <li><strong>Domicilio:</strong> Madrid, España</li>
        <li><strong>Email:</strong> dentainhoa@gmail.com</li>
        <li><strong>Teléfono:</strong> +34 641 712 904</li>
      </ul>

      <h2>2. Objeto</h2>
      <p>El presente aviso legal regula el uso del sitio web <strong>dentainhoa.com</strong>, cuyo objeto es facilitar información sobre los servicios ofrecidos y permitir la reserva de citas de higiene dental a domicilio en la Comunidad de Madrid.</p>

      <h2>3. Condiciones de uso</h2>
      <p>El acceso a este sitio implica la aceptación de las presentes condiciones. El usuario se compromete a hacer un uso lícito y adecuado, absteniéndose de utilizarlo con fines ilícitos o contrarios a la buena fe.</p>

      <h2>4. Propiedad intelectual</h2>
      <p>Todos los contenidos (textos, imágenes, diseño, logotipos) son propiedad del titular y están protegidos por la normativa de propiedad intelectual. Queda prohibida su reproducción sin autorización expresa.</p>

      <h2>5. Responsabilidad</h2>
      <p>El titular no se hace responsable de posibles interrupciones, errores u omisiones en la información. La reserva de una cita a través del formulario no constituye compromiso definitivo hasta la confirmación por email o teléfono.</p>

      <h2>6. Ley aplicable</h2>
      <p>Este aviso se rige por la legislación española. Cualquier controversia se someterá a los juzgados y tribunales de Madrid.</p>

      <p className="text-xs opacity-70 mt-8">Última actualización: julio de 2026.</p>
    </LegalLayout>
  );
}
